var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#B80303",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.008 15.689h11.984a1.125 1.125 0 0 0 .99-1.659L9.99 2.903a1.125 1.125 0 0 0-1.98 0L2.017 14.03a1.125 1.125 0 0 0 .99 1.659"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#B80303",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.798 6.87 9 11.157 9.2 6.871a.202.202 0 1 0-.403-.002"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#B80303",
    d: "M9 13.966a.703.703 0 1 1 0-1.406.703.703 0 0 1 0 1.406"
  })));
};
export default SvgWarning;